// node_modules
import React, { useEffect, useContext } from "react";
import { Button } from "primereact/button";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// redux
import { useLogoutMutation } from "../redux/services/auth";
import { useGetMeQuery } from "../redux/services/user";
import {setLoading, setShowMobileSidebar} from '../redux/slices/app.slice'

// context
import { ToastContext } from "../App";

// styles
import * as styles from "./Header.module.css";

// img
import logo from "../../public/images/logo.svg";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const showToast = useContext(ToastContext);

  const orders = useSelector((state) => state.orders.orders);
  const openedStations = useSelector((state) => state.stations.openedStations);
  const sidebarVisible = useSelector((state) => state.app.sidebarVisible);
  const showMobileSidebar = useSelector((state) => state.app.showMobileSidebar);

  const [
    logout,
    { isSuccess: isLogoutSuccess, isError: isLogoutError, error: logoutError },
  ] = useLogoutMutation();
  const {
    data: user,
    isSuccess: isGetUserSuccess,
    isError: isGetUserError,
  } = useGetMeQuery();

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    if (isGetUserSuccess || isGetUserError) {
      dispatch(setLoading(false));
    }
  }, [isGetUserSuccess, isGetUserError]);

  useEffect(() => {
    if (isLogoutError) {
      showToast("error", logoutError?.status, logoutError?.data?.message);
    }
  }, [isLogoutError]);

  useEffect(() => {
    if (isLogoutSuccess) {
      showToast("success", "Success", "Logged out successfully");
      navigate("/login");
    }
  }, [isLogoutSuccess]);

  const toggleSidebar = () => {
    dispatch(setShowMobileSidebar(!showMobileSidebar))
  }
  
  const logoLink = () => {
    if (location.pathname === "/login") {
      return "/login";
    }

    switch (user?.role) {
      case "admin":
        return "/app/admin";
      case "manager":
        return "/app/manager";
      case "chef":
        return "/app/chef";
      default:
        return "/";
    }
  };

  // if (location.pathname === "/login") {
  //   return null;
  // }
  
  return (
    <header className={`${styles.header}`}>
      <div
        className={
          location.pathname === "/" ||
          location.pathname === "/order-status" ||
          location.pathname.startsWith("/make-order")
            ? styles.containerStudent
            : styles.container
        }
      >
        {!sidebarVisible && (location.pathname.startsWith("/app/manager") || location.pathname.startsWith("/app/admin")) && (
          <Button icon={`pi ${showMobileSidebar ? "pi-times" : "pi-align-justify"}`} rounded text severity="secondary" onClick={toggleSidebar} className={styles.sidebarBtn} />
        )}
        
        <Link to={logoLink()}>
          <img className={styles.logo} src={logo} alt="" />
        </Link>

        <>
          {openedStations?.length !== 0 && orders?.length && location.pathname === "/" && (
            <Link to="/order-status" className={styles.orderStatusLink}>
              <i className="pi pi-clock"></i>
              <div>MY ORDERS</div>
            </Link>
          )}
          {localStorage.getItem("access_token") && sidebarVisible && (
            <Button
              label="LOG OUT"
              icon="pi pi-sign-out"
              className={`p-button-outlined ${styles.logoutButton}`}
              onClick={handleLogout}
            />
          )}
        </>
      </div>
    </header>
  );
};

export default Header;
